import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Product from '@/components/Product'
import SelfPrinting from '@/components/SelfPrinting'
import ShopSelfPrinting from '@/components/ShopSelfPrinting'
import SharePrinting from '@/components/SharePrinting'
import ShopSharePrinting from '@/components/ShopSharePrinting'
import AboutUs from '@/components/AboutUs'
import ServiceSupport from '@/components/ServiceSupport'
import Join from '@/components/Join'
import printSolution from '@/components/PrintSolution'
import OfficeSolution from '@/components/OfficeSolution'
import ShareSolution from '@/components/ShareSolution'
import CopierSelfprinting from '@/components/CopierSelfprinting'
import Different from '@/components/Different'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '印点点自助打印 - 自助打印软件 - 自助打印系统 – 共享打印系统',
      description: '印点点自助打印软件，提供电脑自助打印软件、手机自助打印软件，支持oem贴牌，diy自己专属的自助打印品牌，全国15000+网点都在使用的自助打印系统。',
      keywords: '印点点自助打印软件,自助打印软件,自助打印系统,自助打印,共享打印软件,共享打印系统',
    },
  },
  {
    path: '/Product',
    name: 'Product',
    component: Product,
    meta: {
      title: '印点点自助打印软件 - 电脑/手机自助打印软件 - 10000+间文印店免费试用',
      description: '印点点自助打印软件，支持图文快印店主免费下载安装试用，实现顾客自助打印、智能计价收费，提供电脑自助打印、手机自助打印、远程预约打印、证件照自助打印等打印功能，全国10000+间文印店免费试用。',
      keywords: '自助打印,电脑自助打印,手机自助打印,电脑自助打印软件,自助打印软件,手机自助打印软件,手机自助打印系统',
    },
  },
  {
    path: '/SelfPrinting',
    name: 'SelfPrinting',
    component: SelfPrinting,
    meta: {
      title: '印点点自助打印软件 - 自助打印系统 - 电脑自助打印软件 - 手机自助打印',
      description: '印点点自助打印软件，提供电脑自助打印软件、手机自助打印软件，支持oem贴牌，diy自己专属的自助打印品牌，全国15000+网点都在使用的自助打印系统。',
      keywords: '印点点自助打印软件,自助打印系统,电脑自助打印软件,手机自助打印软件,电脑自助打印,手机自助打印,自助打印',
    },
  },
  {
    path: '/SharePrinting',
    name: 'SharePrinting',
    component: SharePrinting,
    meta: {
      title: '印点点共享打印软件 - 共享打印系统 - 扫码付费自助打印软件',
      description: '印点点共享打印软件，全新一代扫码付费共享打印软件，无需电脑，无需打印盒子，30秒快速接入，助力共享经济，全国已超过30000+网点在使用。',
      keywords: '共享打印系统,自助打印,共享打印软件,自助打印系统,扫码付费打印系统,扫码付费自助打印,扫码付费手机自助打印',
    },
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      title: '关于我们 - 印点点云打印 - 印点点自助打印',
      description: '印点点自助打印，隶属于深圳市印点点科技有限公司旗下品牌。印点点自主研发的打印软件，使普通打印机具有远程打印、共享打印、自助打印、扫码打印、刷卡打印、云打印等联网功能。',
      keywords: '印点点,云打印,自助打印,印点点云打印',
    },
  },
  {
    path: '/ServiceSupport',
    component: ServiceSupport,
    name: "ServiceSupport",
    children: [
      // {
      //   path: "/ServiceSupport",
      //   name: "ServiceSupport",
      //   component: resolve => require(["@/components/comm/serviceComm.vue"], resolve)
      // },
      {
        path: "/ServiceSupport",
        name: "ServiceSupport",
        component: resolve => require(["@/components/comm/cloudBox.vue"], resolve),
        meta: {
          title: '印点点服务中心 - 印点点客服电话 - 印点点自助打印',
          description: '印点点在线服务中心，工作时间周一至周五(09:00-18:30)，用户可在此了解印点点企业办公、印点点共享办公、印点点快印自助相关信息。印点点自助打印，随时随地，想印就印。',
          keywords: '印点点服务中心,印点点客服电话,印点点自助打印',
        },
      },
      {
        path: "/DownLoad",
        name: "DownLoad",
        component: resolve => require(["@/components/comm/printing.vue"], resolve),
        meta: {
          title: '自助打印软件免费下载 - 智能打印系统免费版试用 - 印点点自助打印',
          description: '印点点自助打印系统，勇于突破传统打印模式，支持电脑自助打印、手机自助打印。印点点自助打印下载中心，提供自助打印软件免费下载，打印店必备自助打印软件，全面解放人力，降低人工成本。目前已合作数千家图文打印店，累积服务上百万使用用户。',
          keywords: '自助打印软件免费下载,自助打印软件下载,智能打印系统,智能打印软件下载',
        },
      },
      {
        path: "/ServiceSupport/issueSolving",
        name: "issueSolving",
        component: resolve => require(["@/components/comm/issueSolving.vue"], resolve)
      },
      {
        path: "/ServiceSupport/scene",
        name: "scene",
        component: resolve => require(["@/components/comm/scene.vue"], resolve)
      },
    ]
  }, {
    path: '/Join',
    name: 'Join',
    component: Join,
    meta: {
      title: '共享打印系统加盟 - 自助打印软件代理 - 印点点云打印小程序加盟',
      description: '印点点在线服务中心，工作时间周一至周五(09:00-18:30)，用户可在此了解印点点企业办公、印点点共享办公、印点点快印自助相关信息。印点点自助打印，随时随地，想印就印。',
      keywords: '印点点服务中心,印点点客服电话,印点点自助打印',
    },
  }, {
    path: '/printSolution',
    name: 'printSolution',
    component: printSolution,
    meta: {
      title: '图文店自助打印软件 - 文印店自助打印系统 - 微信扫码付费打印 - 印点点自助打印',
      description: '印点点共享打印加盟代理中心，用户可在此了解共享打印系统加盟、自助打印软件代理、共享打印小程序加盟。印点点云打印，赋能打印厂商、渠道商、投放商，随时随地，想印就印。',
      keywords: '图文店自助打印软件,文印店自助打印系统,微信扫码打印,扫码付费打印',
    },
  }, {
    path: '/OfficeSolution',
    name: 'OfficeSolution',
    component: OfficeSolution,
    meta: {
      title: '企业微信扫码打印 - 钉钉扫码快印 - welink扫码打印 - 印点点云打印',
      description: '印点点云打印企业办公解决方案栏目，用户可在此了解企业微信扫码打印、钉钉扫码快印、welink扫码打印、飞书扫码打印等信息。印点点云打印，助力企业云上办公，开启云端一体化新征程。',
      keywords: '企业微信扫码打印,钉钉扫码快印,welink扫码打印,印点点云打印',
    },
  }, {
    path: '/ShareSolution',
    name: 'ShareSolution',
    component: ShareSolution,
    meta: {
      title: '共享打印软件 - 共享打印小程序 - 共享打印源码品牌 - 印点点自助打印',
      description: '印点点自助打印，提供共享打印软件、共享打印小程序、共享打印源码，支持免费试用。印点点自助打印，赋能运营商、投放商，打造属于自己的自助打印品牌。',
      keywords: '共享打印软件,共享打印小程序,共享打印源码品牌',
    },
  }, {
    path: '/RegisterChoice',
    name: 'RegisterChoice',
    component: resolve => require(["@/components/Register/RegisterChoice.vue"], resolve)
  },
  {
    path: '/Register',
    name: 'Register',
    component: resolve => require(["@/components/Register/Register.vue"], resolve)
  },
  {
    path: '/PrintingManagement',
    name: 'PrintingManagement',
    component: resolve => require(["@/components/H5/CloudOffice.vue"], resolve),
    meta: {
      title: '云办公',
    },
  },
  {
    path: '/PrinterMeterReading',
    name: 'PrinterMeterReading',
    component: resolve => require(["@/components/H5/CloudOperation.vue"], resolve),
    meta: {
      title: '云运维',
    },
  },
  {
    path: '/ProductMap',
    name: 'ProductMap',
    component: resolve => require(["@/components/H5/ProductMap.vue"], resolve),
    meta: {
      title: '印点点推广商',
    },
  },
  {
    path: '/ShopSelfPrinting',
    name: 'ShopSelfPrinting',
    component: ShopSelfPrinting,
    meta: {
      title: '印点点自助打印软件 - 电脑/手机自助打印软件 - 10000+间文印店免费试用',
      description: '印点点自助打印软件，支持图文快印店主免费下载安装试用，实现顾客自助打印、智能计价收费，提供电脑自助打印、手机自助打印、远程预约打印、证件照自助打印等打印功能，全国10000+间文印店免费试用。',
      keywords: '自助打印,电脑自助打印,手机自助打印,电脑自助打印软件,自助打印软件,手机自助打印软件,手机自助打印系统',
    },
  },
  {
    path: '/ShopSharePrinting',
    name: 'ShopSharePrinting',
    component: ShopSharePrinting,
    meta: {
      title: '印点点共享打印系统 - 扫码付费自助打印软件 - 15000多家打印网点在使用',
      description: '印点点共享打印系统，全国已超过10000多家高校和社会打印网点在使用，专业提供扫码付费自助打印软件，无需投入设备，快速接入，全面解放人力、降低人工成本。',
      keywords: '共享打印系统,自助打印,共享打印软件,自助打印系统,扫码付费打印系统,扫码付费自助打印,扫码付费手机自助打印',
    },
  },
  {
    path: '/CopierSelfprinting',
    name: 'CopierSelfprinting',
    component: CopierSelfprinting,
    meta: {
      title: '复印机自助打印软件 - 自助复印系统 - 柯美/震旦/爱普生/富士施乐复印机自助打印',
      description: '印点点开发的复印机自助打印软件，提供自助打印、自助复印、自助扫描功能，轻松实现无人智能打印，支持柯美复印机自助打印,震旦复印机自助打印,爱普生复印机自助打印,富士施乐复印机自助打印。',
      keywords: '复印机自助打印软件,自助复印软件,自助复印系统,柯美复印机自助打印软件,震旦打印机自助打印软件,爱普生复印机自助打印软件,富士施乐复印机自助打印软件',
    },
  },
  {
    path: '/Different',
    name: 'Different',
    component: Different,
    meta: {
      title: '软件对比',
    },
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js